import robotUrl from '../assets/axiworks-robot.png';

/**
 * AiAvatar — AI 어시스턴트 마스코트(axiworks-robot) 이미지. 기존 `<Bot>` 아이콘 자리를 대체한다.
 * (2026-06-30) 컨테이너(아바타 박스)가 크기·모양·배경을 제공하고, 이미지는 그 안을 채운다.
 *
 *  - variant='face' (기본): cover + top — 작은 아바타에서 로봇 상단(얼굴) 위주로 꽉 채움.
 *  - variant='full'        : contain — 큰 장식용 자리(모달 hero 등)에서 로봇 전체 표시.
 *
 * 접근성: 컨테이너에 aria-label(AI 어시스턴트)이 이미 있으므로 이미지는 aria-hidden + alt 빈값.
 */
export function AiAvatar({ variant = 'face' }: { variant?: 'face' | 'full' }) {
  return <img className={`ai-robot-img ai-robot-img--${variant}`} src={robotUrl} alt="" aria-hidden />;
}
